import {
  PrinterBrand,
  PrinterConnection,
  PrinterErrorCode,
} from '@vgrubs/components';

/** How a tablet printer's report reads, in the problem detail and on the location. */

export const PRINTER_ERROR_LABEL: Record<PrinterErrorCode, string> = {
  paperOut: 'Out of paper',
  paperNearEnd: 'Paper running low',
  coverOpen: 'Cover open',
  offline: 'Offline',
  notConnected: 'Not connected',
  overheat: 'Overheating',
  cutterError: 'Cutter error',
  unknown: 'Unknown error',
};

/** "vgrubs" is our own printer and reads as such. */
export const PRINTER_BRAND_LABEL: Record<PrinterBrand, string> = {
  epson: 'Epson',
  star: 'Star',
  vgrubs: 'vGrubs printer',
};

export const PRINTER_CONNECTION_LABEL: Record<PrinterConnection, string> = {
  bluetooth: 'Bluetooth',
  usb: 'USB',
  network: 'Network',
  builtin: 'Built-in',
};

/** "Epson · Bluetooth", whichever of the two is known. */
export const printerKindLabel = (
  brand?: PrinterBrand | null,
  connection?: PrinterConnection | null
) =>
  [
    brand ? PRINTER_BRAND_LABEL[brand] ?? brand : null,
    connection ? PRINTER_CONNECTION_LABEL[connection] ?? connection : null,
  ]
    .filter(Boolean)
    .join(' · ');
